import React from "react";
/*import ContactOneForm from "./ContactOneForm";*/
import ContactOneInfoItem from "./ContactOneInfoItem";
/*import { FaTelegram } from "react-icons/fa";*/
const ContactOne = () => {
  const info_items = [
    {
      icon: "fa-envelope",
      content: (
        <>E-mail<br />
          hello@ fltr.co.in
        </>
      ),
    },
    {
      icon: "fa-telegram",
      content: (
        <>
          Telegram
          <br /> <a href={"https://t.me/fullthrottleofficial"} aria-label={"Full Throttle Token Telegram"}>@fullthrottleofficial</a>
        </>
      ),
    },
    {
      icon: "fa-twitter",
      content: (
        <>
          Twitter
          <br /> <a href={"https://twitter.com/fltrtoken"} aria-label={"Full Throttle Token Twitter"}>@fltrtoken</a>
        </>
      ),
    },
  ];

  return (
    <section id="contact" className="contact-area pt-70 pb-110">
      <div className="container">
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-70">
              <span className="sub-title">Contact</span>
              <h2 className="title">
                <span>Contact</span> FLTR Token
              </h2>
            </div>
          </div>
        </div>

        {/* secction info */}
        <div className="contact-info-wrap">
          <div className="row justify-content-center">
            {info_items.map((x, index) => (
              <div key={index} className="col-lg-4 col-sm-6">
                <ContactOneInfoItem item={x} />
              </div>
            ))}
          </div>
        </div>

        {/* section form */}
        {/*<ContactOneForm />*/}
      </div>
    </section>
  );
};

export default ContactOne;
